import { ICreateContratoInformacoesUseCase } from "../../../presentation/useCases/create/create_contrato_informacoes_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// CreateContratoInformacoesUseCase


export class CreateContratoInformacoesUseCase implements ICreateContratoInformacoesUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createContratoInformacoes(IdContrato: number,DescInformacoes: string | null,Responsavel: string | null,IdFuncionario: number | null,Data: Date | null): Promise<void> {
    
    await this.repository.createContratoInformacoes(
      IdContrato, DescInformacoes, Responsavel, IdFuncionario, Data
    );
  }
}
